<template>
  <div class="dboard">
    <div class="dboard-header">
      <portal target-el="#filter">
        <primary-filter
          v-if="selectedCategory"
          :menuOptions="menuOptions"
          :selectedCategory="selectedCategory"
          :noSearchFilter="true"
          @changeCategory="changeCategory" />
      </portal>
    </div>

    <div class="ifame-block">
      <iframe allowfullscreen
        v-if="getDashboard && !isIframeLoading"
        id="iframeContent"
        class="responsive-iframe"
        frameborder='0'
        style='border:0'
        :src="iframeUrl" />
        <Spinner v-else />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { Dashboard } from 'pando-dashboard';
import { cloneDeep } from 'lodash';
import { dashboardMenu } from '@/constants/dashboardConstants';
import PrimaryFilter from '@/components/common/PrimaryFilter';

export default {
  components: {
    PrimaryFilter,
  },
  data() {
    return {
      dashboardMenu,
      menuOptions: [],
      iframeUrl: '',
      urls: [],
      defaultValues: {},
      isIframeLoading: true,
    };
  },
  computed: {
    ...mapGetters({
      currentClient: 'app/currentClient',
      currentUser: 'app/currentUser',
      dashboardConfig: 'dashboard/getDashboardConfig',
      dashboardParams: 'dashboard/getDashboardParams',
      category: 'dashboard/getCategory',
      quickSightDashboardConfig: 'dashboard/getDashboardQuickSightConfig',
      configurations: 'app/configurations',
      dashboardOptions: 'app/dashboardOptions',
    }),
    selectedCategory() {
      return this.dashboardOptions.find(menu => menu.id === this.category);
    },
    getDashboard() {
      if (!this.iframeUrl && this.dashboardConfig && !this.dashboardConfig.isQuickSight) {
        const urlData = {
          dashboardId: this.dashboardConfig.dashboard_id,
          sharingToken: this.dashboardConfig.sharing_token,
          isDrillDown: this.dashboardConfig.isDrillDown,
        };
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.iframeUrl = this.constructURL(urlData);
      } else if (this.dashboardConfig && this.dashboardConfig.isQuickSight
      && this.quickSightDashboardConfig &&
      this.quickSightDashboardConfig.EmbedUrl) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.iframeUrl = this.quickSightDashboardConfig.EmbedUrl;
      }
      return this.iframeUrl;
    },
  },
  async created() {
    await this.initialization();
  },
  methods: {
    initialization() {
      this.menuOptions = this.$checkMenuOptions(this.dashboardOptions);
      if (this.$route.query && this.$route.query.id) {
        if (!this.dashboardConfig) {
          const option = this.menuOptions.filter(item => item.id === this.$route.query.id);
          this.changeCategory(option[0]);
        }
      } else {
        const option = this.menuOptions.filter(item => item.id !== 'LiveDashboard');
        this.changeCategory(option[0]);
      }
      const parentWindow = window.parent;
      parentWindow.addEventListener('message', this.generateCluvioURL);
      parentWindow.addEventListener('popstate', this.backFunction);
    },
    backFunction($event) {
      const paramsArray = cloneDeep(this.dashboardParams);
      paramsArray.pop();
      this.$store.commit('dashboard/setDashboardParams', paramsArray);
      this.urls.pop();
      const currentIframe = document.getElementById('iframeContent');
      this.changeIframeSrc(currentIframe, this.urls[this.urls.length - 1]);
    },
    changeIframeSrc(iframe, src) {
      if (iframe != null) {
        const frame = iframe.cloneNode(true);
        frame.src = src;
        iframe.parentNode.replaceChild(frame, iframe);
      }
    },
    async changeCategory(data) {
      try {
        this.isIframeLoading = true;
        const result = await this.$store.dispatch('dashboard/dashboardConfig',
          { name: data.id });
        const quickSightResult = await this.$store.dispatch('dashboard/quickSightDashboardConfig',
          { name: data.id });
        if (result) {
          this.iframeUrl = '';
          this.urls = [];
          this.$router.push({ name: 'Dashboard', query: { id: data.id } });
          this.isIframeLoading = false;
        } else {
          this.$errorMessage({ message: this.$getErr('DASHBOARD_NOT_DEFINED') });
          this.isIframeLoading = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    generateCluvioURL($event) {
      try {
        if ($event && $event.data) {
          const data = JSON.parse($event.data);
          if (data.event === 'parametersChanged' && data.params && data.params.parameters) {
            const parameters = data.params.parameters;
            const params = {
              filters: [],
              timerange: data.params.parameters.timerange,
            };
            parameters.filters.forEach((item) => {
              params.filters.push({
                key: item.filter_name,
                value: item.selected_values,
              });
            });
            const temp = cloneDeep(this.dashboardParams);
            temp[temp.length - 1] = params;
            this.$store.commit('dashboard/setDashboardParams', temp);
          }
          if (data.event === 'drillDown' && data.params && data.params.dashboardId) {
            const dashboardId = data.params.dashboardId;
            const drillDown = dashboardId && this.dashboardConfig.drill_downs.find(config =>
              config.dashboard_id === dashboardId);
            const filters = data.params.filters;
            const params = [];
            filters.forEach((item) => {
              params.push({
                key: item.filterVariable,
                value: [item.value],
              });
            });
            if (drillDown) {
              const urlData = {
                dashboardId: drillDown.dashboard_id,
                sharingToken: drillDown.sharing_token,
                isDrillDown: drillDown.isDrillDown,
                filters: params,
              };
              this.iframeUrl = this.constructURL(urlData);
            }
          }
        }
      } catch (err) {
        // Log
      }
    },
    constructURL(urlData) {
      const sharingSecret = Dashboard.getJWTSharingSecret(urlData.sharingToken,
        this.currentClient.id, this.currentUser.id, this.getHiddenReports());

      const paramsArray = cloneDeep(this.dashboardParams);
      const currentParam = paramsArray[paramsArray.length - 1];
      const params = currentParam.filters.map((item) => {
        const obj = urlData.filters && urlData.filters.find(o => o.key === item.key);
        return { ...item, ...obj };
      });
      const filterList = [];
      for (let index = 0; index < params.length; index += 1) {
        const value = params[index].value.map(val => `"${val}"`).join(',');
        filterList.push(`"${params[index].key}":[${value}]`);
      }
      const filters = filterList.join(',');

      // Time Range
      const time = urlData.filters && urlData.filters.find(item => item.key === 'timerange');
      const timerange = (time && time.value) || currentParam.timerange;

      // Save the params
      const dashboardParams = {
        filters: params,
        timerange,
      };
      const temp = cloneDeep(this.dashboardParams);
      temp.push(dashboardParams);
      this.$store.commit('dashboard/setDashboardParams', temp);

      let link = `https://dashboards.cluvio.com/dashboards/${urlData.dashboardId}/shared?`;
      link += `sharingToken=${urlData.sharingToken}`;
      link += `&sharingSecret=${sharingSecret}`;
      if (filters) {
        link += `&filters={${filters}}`;
      }
      if (timerange) {
        link += `&timerange=${timerange}`;
      }
      if (urlData.isDrillDown) {
        link += '&enableDrillEvents=true';
      }
      this.urls.push(link);
      const stateObj = {
        url: link,
      };
      const currentIframe = document.getElementById('iframeContent');
      this.changeIframeSrc(currentIframe, link);
      window.history.pushState(stateObj, '', '');
      return link;
    },
    getHiddenReports() {
      if (this.configurations.dashboard && this.configurations.dashboard.hidden_reports) {
        return this.configurations.dashboard.hidden_reports[this.category] || [];
      }
      return [];
    },
  },
};
</script>
<style lang="scss">
.ifame-block {
  width: 1366px;
  margin: 0 auto;
  padding: 20px 0;
  iframe {
    margin-left: -1px;
  }
}
.responsive-iframe {
  position: absolute;
  top: 100px;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>
